<template>
	<div class="help-sidebar" :class="{ 'sidebar-hidden': !sidebarIsVisible }">
		<button @click="toggleSidebar" class="close-button">
			<icon name="arrow-left-to-line" />
		</button>
		<iframe v-if="sidebarIsVisible" :src="`${helpEndpoint}/help/${currentHelpTag}`" height="100%" width="100%" frameBorder="0"></iframe>
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		name: 'help-sidebar',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			helpTag: {
				required: true,
				default: '',
				type: String
			}
		},
		emits: ['update:visible'],
		computed: {
			...mapState({
				modalPages: (state) => state.modals,

			}),
			sidebarIsVisible: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			},
			currentHelpTag() {
				if (this.modalPages.length) {
					return typeof (this.modalPages.at(-1).component.modal.helpTag) === 'function' ? this.modalPages.at(-1).component.modal.helpTag(this.modalPages.at(-1)) : this.modalPages.at(-1).component.modal.helpTag
				}
				else {
					console.log(this)
					return typeof (this.helpTag) === 'function' ? this.helpTag(this) : this.helpTag || ''
				}
			}
		},
		data() {
			return {
				helpEndpoint: import.meta.env.VITE_HELP_ENDPOINT
			}
		},
		methods: {
			toggleSidebar() {
				this.sidebarIsVisible = !this.sidebarIsVisible
			}
		}
	}
</script>

<style></style>